// extracted by mini-css-extract-plugin
module.exports = {"cardsWrapper":"UserGrid_cardsWrapper__32baV","loadingWrapper":"UserGrid_loadingWrapper__1uvd-","notFound":"UserGrid_notFound__1aYGA"};